import { FC } from 'react';

import { InputAdornment, Typography } from '@mui/material';

import { Flex } from 'src/components/Flex';
import { ChargeInput } from 'src/components/FormikComponents';
import NPICurrencyInputField from 'src/components/FormikComponents/NPICurrencyInputField/NPICurrencyInputField';
import { AdditionalCharge } from 'src/hooks/useTransactionCharges';

import { CardOption } from '../..';
import { CustomGridItem } from '../CustomGridItem';
import TransactionChargeValueNonEditable from '../TransactionChargeValueNonEditable';

interface CustomGridInput {
    card?: CardOption;
    name?: string;
    editable?: boolean;
    charge?: AdditionalCharge;
    componentType?: 'card-charges' | 'additional-tariffs';
}

export const CustomGridInput: FC<CustomGridInput> = ({
    card,
    name,
    editable,
    componentType,
    charge,
}) => {
    return (
        <>
            {componentType === 'card-charges' && (
                <CustomGridItem
                    item1={<Typography>{card?.label}</Typography>}
                    item2={
                        <Flex gap="24px" marginBottom="16px">
                            <ChargeInput
                                name={`${name}.percentageBaseRate`}
                                disabled={
                                    !editable || card?.type === 'PER_ITEM' || card?.isConstant
                                }
                                endAdornment={<InputAdornment position="start">%</InputAdornment>}
                                min={card?.percentageLowestRate}
                                max={card?.percentageHighestRate}
                            />
                            <NPICurrencyInputField
                                fieldName={`${name}.perItemBaseRate`}
                                disabled={
                                    !editable || card?.type === 'PERCENTAGE' || card?.isConstant
                                }
                                min={card?.perItemLowestRate}
                                max={card?.perItemHighestRate}
                            />
                        </Flex>
                    }
                    item3={
                        <Flex gap="24px">
                            <ChargeInput
                                name={`${name}.refundPercentage`}
                                disabled
                                endAdornment={<InputAdornment position="start">%</InputAdornment>}
                            />
                            <TransactionChargeValueNonEditable
                                fieldName={`${name}.refundCostPerItem`}
                            />
                        </Flex>
                    }
                />
            )}

            {componentType === 'additional-tariffs' && (
                <CustomGridItem
                    item1={<Typography>{charge?.label}</Typography>}
                    item2={
                        <Flex gap="24px">
                            <ChargeInput
                                name={`${name}.creditCardPercentage`}
                                disabled
                                endAdornment={<InputAdornment position="start">%</InputAdornment>}
                            />
                            <TransactionChargeValueNonEditable
                                fieldName={`${name}.creditCardPerItem`}
                            />
                        </Flex>
                    }
                    item3={
                        <Flex gap="24px">
                            <ChargeInput
                                name={`${name}.debitCardPercentage`}
                                disabled
                                endAdornment={<InputAdornment position="start">%</InputAdornment>}
                            />
                            <TransactionChargeValueNonEditable
                                fieldName={`${name}.debitCardPerItem`}
                            />
                        </Flex>
                    }
                />
            )}
        </>
    );
};

export default CustomGridInput;

CustomGridInput.defaultProps = {
    componentType: 'card-charges',
};
